export default "__VITE_ASSET__b715c099__"